// extracted by mini-css-extract-plugin
module.exports = {"cancellation-policy":"cancellation-policy__3o8tA","header":"header__1Rjfs","body":"body__3StDM","supplement":"supplement__21Qef","link":"link__17J4R","red":"red__1hJq8"};